import axios from "axios";

const {REACT_APP_ADMIN_API} = process.env;

export const getHardwareTypes = async (
  cancelToken,
) => {
  const region = localStorage.getItem("region");
  const url = `${REACT_APP_ADMIN_API}/api/hardwaretypes?db=${region}`;
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data };
  } catch (e) {
    return { detail: e.response?.data?.error };
  }
};
